var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_6391_46666)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6391_46666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8519 32.2573C19.8519 33.378 18.7587 33.6166 18.4419 33.6626C17.7012 33.6419 17.1052 33.021 17.1052 32.2573V14.8788H25.3453V13H16.1896C15.6842 13 15.274 13.4208 15.274 13.9394V32.2573C15.274 34.0703 16.7115 35.5451 18.4786 35.5451H32.2121C33.9792 35.5451 35.4167 34.0703 35.4167 32.2573V30.8482H19.8519V32.2573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8388 24.2723C29.4773 24.2723 28.2157 23.8308 27.1765 23.085V28.9692L30.8388 26.1511L34.5011 28.9692V23.085C33.4619 23.8308 32.2003 24.2723 30.8388 24.2723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8387 22.3938C33.367 22.3938 35.4166 20.2909 35.4166 17.6969C35.4166 15.1029 33.367 13 30.8387 13C28.3104 13 26.2609 15.1029 26.2609 17.6969C26.2609 20.2909 28.3104 22.3938 30.8387 22.3938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6391_46666",
    x1: 7.94287,
    y1: 7,
    x2: 37.4429,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376D77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6391_46666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.4429 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsTrade);
export default __webpack_public_path__ + "static/media/statistics-trade.3054d16a956fc07e55420cd78275d8e2.svg";
export { ForwardRef as ReactComponent };